/*
*   操作日志管理组件
*   zxw
*   2023-04-06
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import { Row, Col, message, Table, Input, Select } from 'antd';
import { UjoinParams, AddRequestHeaders, isGTscreenWidth } from '../../incs/FunHelper.js';

const Option = Select.Option;

class Lists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLists: this.props.dataLists
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    render() {
        const columns = [
            { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
            { title: '操作者', dataIndex: 'operation', key: 'operation', fixed: 'left', },
            { title: '操作对象', dataIndex: 'instance', key: 'instance', },
            { title: '模块', dataIndex: 'module', key: 'module', },
            { title: '动作', dataIndex: 'action', key: 'action', },
            { title: '描述', dataIndex: 'description', key: 'description', },
            { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: 180 },
        ];
        return (
            <div>
                <Table
                    columns={columns}
                    size='middle'
                    dataSource={this.state.dataLists}
                    scroll={{ x: this.props.x }}
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: CNF.pageSize,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current, pageSize) => this.props.changePageSize(pageSize, current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
            </div>
        );
    }
}

class LogOperations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            operation: '',
            instance: '',
            module: '',
            action: ''
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeOperation = (e) => { this.setState({ operation: e.target.value }); }
    changeInstance = (e) => { this.setState({ instance: e.target.value }); }
    changModule = (value) => { this.setState({ module: value ? value : '' }); this.search(); }
    changAction = (value) => { this.setState({ action: value ? value : '' }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    /**
     * 获取操作日志列表
     */
    getLists() {
        const _this = this;
        const params = {
            'operation': this.state.operation,
            'instance': this.state.instance,
            'module': this.state.module,
            'action': this.state.action,
            'page_size': isGTscreenWidth ? CNF.pageSize : CNF.pageSize - 2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}log/operations${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        })
            .done(function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            })
            .fail(function (data) {
                message.error(data.responseJSON.detail, CNF.messageDuration);
            })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <div>
                <Row style={{ height: 60, paddingTop: 10, paddingLeft: 20 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            onChange={this.changeOperation}
                            onPressEnter={this.search}
                            placeholder='操作者'
                            value={this.state.operation}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 4 : 5} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeInstance}
                            onPressEnter={this.search}
                            placeholder='操作对象'
                            value={this.state.instance}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='模块'
                            style={{ width: '100%' }}
                            onChange={this.changModule}
                        >
                            {
                                CNF.navItems.map((item) => {
                                    return item.submenu && item.submenu.map((item2, index2) => {
                                        if (item2.isLogModule && this.props.btnLists.indexOf(item2.ptn) >= 0) {
                                            return <Option key={index2} value={item2.name}>{item2.name}</Option>
                                        }
                                        return ''
                                    })
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='动作'
                            style={{ width: '100%' }}
                            onChange={this.changAction}
                        >
                            {
                                Object.keys(CNF.actionName).map((key) => {
                                    if (CNF.actionName[key] === '导出') return null;
                                    return <Option key={key} value={CNF.actionName[key]}>{CNF.actionName[key]}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default LogOperations